export interface VodRef {
	service?: string;
	id?: string;
}

/**
 * Build embed URL for iframes (Twitch player, YouTube embed).
 * Twitch requires the parent param to match the embedding page's host (e.g. romhackraces.online).
 */
export function getVodEmbedUrl(vod: VodRef | undefined): string | undefined {
	if (!vod?.service || !vod?.id) return undefined;
	if (vod.service === 'twitch') {
		const parent = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
		return `https://player.twitch.tv/?video=${vod.id}&parent=${encodeURIComponent(parent)}&autoplay=false`;
	}
	if (vod.service === 'youtube') {
		return `https://www.youtube.com/embed/${vod.id}?autoplay=0`;
	}
	return undefined;
}
